module.exports = "<footer id={{_UID_}} class=\"app-footer indexed\"> <div class=fixed-content-container> <p>© 2018 iExpenseOnline.com</p> <a href=/terms-of-service class=terms>Terms of Service</a> <a href=/contact-us class=contact>Contact Us</a> </div> </footer>";


//////////////////
// WEBPACK FOOTER
// ./src/view/footer/Footer.html
// module id = 52
// module chunks = 15